export function formatDurationCountdown(milliseconds) {
  const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000))
  const months = Math.floor(totalSeconds / 2592000)
  const daysAfterMonths = Math.floor((totalSeconds % 2592000) / 86400)
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  function formatUnit(value, singular, plural) {
    return `${value} ${value === 1 ? singular : plural}`
  }

  if (months > 0) {
    return `${formatUnit(months, 'Month', 'Months')} ${formatUnit(
      daysAfterMonths,
      'Day',
      'Days',
    )}`
  }

  if (days > 0) {
    return `${formatUnit(days, 'Day', 'Days')} ${formatUnit(
      hours,
      'Hour',
      'Hours',
    )}`
  }

  if (hours > 0) {
    return `${formatUnit(hours, 'Hour', 'Hours')} ${formatUnit(
      minutes,
      'Minute',
      'Minutes',
    )}`
  }

  return `${formatUnit(minutes, 'Minute', 'Minutes')} ${formatUnit(
    seconds,
    'Second',
    'Seconds',
  )}`
}
